import { render, staticRenderFns } from "./TitleWidget.vue?vue&type=template&id=227af910&scoped=true&"
import script from "./TitleWidget.vue?vue&type=script&lang=js&"
export * from "./TitleWidget.vue?vue&type=script&lang=js&"
import style0 from "./TitleWidget.vue?vue&type=style&index=0&id=227af910&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227af910",
  null
  
)

export default component.exports